import { Component, Input, ViewChild, forwardRef, OnChanges, SimpleChanges, ElementRef, Renderer, EventEmitter, Output, ContentChild, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, SelectControlValueAccessor } from "@angular/forms";
import { SELECT_VALUE_ACCESSOR } from "@angular/forms/src/directives/select_control_value_accessor";
import { inputType } from "../config";
import { PatternConstants } from "../../shell/shared/pattern.constants";

@Component({
    selector: 'ixs-multiinput',
    templateUrl: 'ixsmutiinput.component.html',
    // providers: [
    //     {
    //         provide: NG_VALUE_ACCESSOR,
    //         useExisting: forwardRef(() => IXSMultiInputComponent),
    //         multi: true
    //     }
    // ]
})
export class IXSMultiInputComponent implements AfterViewInit {
    ngAfterViewInit(): void {

    }

    @Input()
    caption: string
}




// WEBPACK FOOTER //
// ./src/app/components/ixsmultiinput/ixsmultiinput.component.ts